__turbopack_context__.v({
  "body": "fullSchedule-module-scss-module__RixANq__body",
  "chevron": "fullSchedule-module-scss-module__RixANq__chevron",
  "dayPart": "fullSchedule-module-scss-module__RixANq__dayPart",
  "dayPartWrapper": "fullSchedule-module-scss-module__RixANq__dayPartWrapper",
  "details": "fullSchedule-module-scss-module__RixANq__details",
  "event": "fullSchedule-module-scss-module__RixANq__event",
  "events": "fullSchedule-module-scss-module__RixANq__events",
  "footer": "fullSchedule-module-scss-module__RixANq__footer",
  "fullWidth": "fullSchedule-module-scss-module__RixANq__fullWidth",
  "full_schedule": "fullSchedule-module-scss-module__RixANq__full_schedule",
  "hasImage": "fullSchedule-module-scss-module__RixANq__hasImage",
  "head": "fullSchedule-module-scss-module__RixANq__head",
  "image_wrapper": "fullSchedule-module-scss-module__RixANq__image_wrapper",
  "isSchedulePage": "fullSchedule-module-scss-module__RixANq__isSchedulePage",
  "link": "fullSchedule-module-scss-module__RixANq__link",
  "links": "fullSchedule-module-scss-module__RixANq__links",
  "location": "fullSchedule-module-scss-module__RixANq__location",
  "locationWrapper": "fullSchedule-module-scss-module__RixANq__locationWrapper",
  "noEvents": "fullSchedule-module-scss-module__RixANq__noEvents",
  "title": "fullSchedule-module-scss-module__RixANq__title",
});
